import React from "react"
import style from "./style.module.scss"

export default () => {
  return (
    <div className={style.promo}>
      <div className="op__block">
        <div className="container-fluid">
          <div
            className={style.promo__notification}
            data-aos="fade-down"
            data-aos-delay="0"
          >
            <span>
              <span role="img" aria-label="">
                👉
              </span>{" "}
              50% off return customers <a href="#contact__header">Unlock access now</a>
            </span>
          </div>
          <div className={style.promo__inner}>
            <div className="row">
              <div className="col-md-6">
                <h1 data-aos="fade-right">
                  Low Code
                  <br />
                  <strong>UI Development</strong>
                </h1>
                <p
                  className="text-muted"
                  data-aos="fade-right"
                  data-aos-delay="100"
                >
                  You require, we build
                </p>
                <ul
                  className={style.promo__list}
                  data-aos="fade-right"
                  data-aos-delay="200"
                >
                  <li>
                    <span className={style.promo__list__icon}>
                      <img
                        src="/resources/img/icons/gatsby.svg"
                        alt="GatsbyJS"
                      />
                    </span>
                    <span>GatsbyJS Framework</span>
                  </li>
                  <li>
                    <span
                      className={`${style.promo__list__icon} ${style.promo__list__icon__html}`}
                    >
                      <img
                        src="/resources/img/icons/html-5.svg"
                        alt="Static Html"
                      />
                    </span>
                    <span>Static Html</span>
                  </li>
                  <li>
                    <span
                      className={`${style.promo__list__icon} ${style.promo__list__icon__sketch}`}
                    >
                      <img
                        src="/resources/img/icons/sketch.svg"
                        alt="Sketch / Figma / Adobe XD"
                      />
                    </span>
                    <span>Sketch Wireframes</span>
                  </li>
                </ul>
                <div
                  className={style.promo__buttons}
                  data-aos="fade-right"
                  data-aos-delay="300"
                >
                  <a href="https://app.thefoundation.cloud" className="op__btn mr-3">
                    Try the demo
                    <i className="fe fe-box ml-2" />
                  </a>
                </div>
              </div>
              <div className="col-md-6">
                <div
                  className={style.promo__img}
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <img
                    src="/resources/img/promo.png"
                    alt="The Foundation"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
